<template lang="pug">
.rhpa-bottom
  hotdeal(v-if="!shouldDisablePromos" :productId="groupedProduct ? buyRequest.productId : simple.productId" layout="rhpa" :buy-request="buyRequest")
  rhpa-login-drawer(
    v-if="overlay === 'rhpaLogin'"
    @success="addToCart"
    )
  view-in-a-r.ar-view(v-if="arProps && shouldShowAR" v-bind="arProps" :key="buyRequest.productId")
  bin-email-input(:bin="BIN" @signup="clickBinButton($el)")
  RogueButton.rhpa-oos(
    v-if="!groupedProduct && buyRequestStatus === 'oos'"
    color="flat-disabled" width="full"
  ) {{__('Item is Unavailable')}}
  RogueButton.rhpa-bin(
    v-else-if="!groupedProduct && buyRequestStatus === 'bin'"
    width="full"
    :loading="BIN.loading"
    @click="clickBinButton($el)"
  )
    bin-status-text(:bin="BIN" size="large")
  .rhpa-button-only(v-else-if="buttonOnly")
    TotalWeight(:buyRequest="buyRequest")
    RogueButton.a2c(v-if="isOmQuotePage" color="red" width="full" :disabled=false @click="exportToOrderManager()" :loading="inProgress")
      | {{ __('Export to Order Manager') }}
    RogueButton.a2c(v-else color="red" width="full" :disabled="disabled || buyRequestStatus !== ''" @click="addToCart()" :loading="inProgress" data-cnstrc-btn="add_to_cart")
      | {{ __('Add to Cart') }}
  .rhpa-buy(v-else)
    TotalWeight(v-if="!isAccessoryGroupFooter" :buyRequest="buyRequest")
    .rhpa-footer
      buy-request-qty.stepper(
        v-if="!groupedProduct && !virtualGiftCard && !forceShowPrice && !ticketRequired"
        :buyRequest="buyRequest"
      )
      .grouped-price(
        v-if="(groupedProduct && !mainProduct.hundoPricing) || forceShowPrice"
        :class="{wide: ['EUR','GBR'].includes(rogue.site.code)}"
      )
        .lead {{__('Total Price:')}}
        Price(
          v-if="groupedProduct || forceShowPrice"
          :buyRequest="totalPriceBuyRequest"
          :show-excl-vat="true"
          :totalPrice="true"
          theme="grouped-total"
        )
      RogueButton.a2c(v-if="isOmQuotePage" color="red" width="full" :disabled="false" @click="exportToOrderManager()" :loading="inProgress")
        | {{ __('Export to Order Manager') }}
      RogueButton.a2c(v-else-if="quickBuyOnly" color="red" width="full" :disabled="disableBuy" @click="addToCart('buyNow')" :loading="inProgress" data-cnstrc-btn="add_to_cart")
        | {{ __('Buy Now') }}
      RogueButton.a2c(v-else color="red" width="full" :disabled="disableBuy" @click="addToCart()" :loading="inProgress" data-cnstrc-btn="add_to_cart")
        | {{ __('Add to Cart') }}
    RogueButton.buy-now(
      color="red"
      width="full"
      v-if="Boolean(rogue.appContext) && !quickBuyOnly && !isProgram"
      :disabled="disableBuy"
      @click="addToCart('buyNow')"
      data-cnstrc-btn="add_to_cart"
    ) {{ __('Buy Now') }}
    client-only(v-if="!disableDigitalWallets && !quickBuyOnly")
      .digital-wallet-row(v-show="applePayAvailable || googlePayAvailable")
        ApplePay.express-pay-button(
          v-if="applePay"
          v-show="applePayAvailable"
          :buyRequest="expressPaymentBuyRequest"
          :prepurchase="prePurchase"
          :disabled="disableBuy"
          :forceShipping="forceShipping"
          @available="applePayAvailable = $event"
        )
        GooglePay.express-pay-button(
          v-if="googlePay"
          v-show="googlePayAvailable"
          :buyRequest="expressPaymentBuyRequest"
          :prepurchase="prePurchase"
          :disabled="disableBuy"
          :forceShipping="forceShipping"
          @available="googlePayAvailable = $event"
        )
  add-to-wishlist(:buyRequest="buyRequest" :simple="simple" v-if="!hideWishlist && !ticketRequired && !quickBuyOnly" :validate="validate")
  h2.accessories-title.heading-h4(v-if="requiresCustomFooter && accessoryCount") {{ __(mainProduct.name) + ' ' + __('Accessories')}}
    .accessory-count {{ __('Available Options') + ' (' + (accessoryCount)?.toString() + ')' }}
  template(v-if="requiresCustomFooter && accessoryCount")
    .divider
    rhpa-body.option.grouped-rhpa(
      v-for="(accessory, i) in customRhpaAccessories"
      :buyRequest="accessory"
      layout='accessory'
      :groupMeta="groupMeta"
    )
    .custom-divider(v-if="is3DStorageProduct")
    .rhpa-footer
      buy-request-qty.stepper(
        v-if="!groupedProduct && !virtualGiftCard && !forceShowPrice && !ticketRequired"
        :buyRequest="customBuyRequest"
      )
      .grouped-price(
        v-if="(groupedProduct && !mainProduct.hundoPricing) || forceShowPrice"
        :class="{wide: ['EUR','GBR'].includes(rogue.site.code)}"
      )
        .lead {{__('Total Price:')}}
        Price(
          v-if="groupedProduct || forceShowPrice"
          :buyRequest="customBuyRequest"
          :show-excl-vat="true"
          :totalPrice="true"
          theme="grouped-total"
        )
      RogueButton.a2c(v-if="requiresCustomFooter" color="red" width="full" :disabled="!canAddAccessories" @click="addAccessoriesToCart()" :loading="inProgress" )
        | {{ __('Add Accessories') }}
      RogueButton.a2c(v-else color="red" width="full" :disabled="disableBuy" @click="addToCart()" :loading="inProgress" data-cnstrc-btn="add_to_cart")
        | {{ __('Add to Cart') }}
</template>
<script setup lang="ts">
import { defineAsyncComponent, inject, type PropType, computed, ref, toRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useBackInStock } from '../bin/useBackInStock'
import { getBuyRequestMeta } from '@/js/helpers/buy-request'
import stockStatus from '@/js/helpers/stockStatus'
import type { BuyRequest } from '@/js/services/RogueTypes'
import { useConfigStore } from '@/js/stores/configStore'
import { useCustomerStore } from '@/js/stores/customerStore'
import { useListStore } from '@/js/stores/listStore'
import { useProductStore } from '@/js/stores/productStore'
import { useUIStore } from '@/js/stores/uiStore'
import { useRogue } from '@/js/services/Rogue'
import { messages } from '@/js/app-bridge/messages'
import { validate as validateHelper } from '@/js/helpers/validate-fns'
import BinStatusText from '@/js/components/bin/bin-status-text.vue'
import BinEmailInput from '@/js/components/bin/bin-email-input.vue'
import BuyRequestQty from '@/js/components/buy-request-qty.vue'
import AddToWishlist from '@/js/components/add-to-wishlist.vue'
import TotalWeight from '@/js/components/rhpa/total-weight.vue'
import { ML_SLINGER_X_ADDON_GROUP_SKU } from '@/js/pages/product/rackbuilder/products/rack/functionalTrainer/FM/slinger-x/slingerXConstants'
import { isEnabledCustomProduct, prepareCustomProductForCart } from '@/js/customProducts/registry'
import { useMassStorage } from '@/js/composables/useMassStorage'
import { raiseShortKitPanels } from '@/js/pages/product/rackbuilder/utils/mms-utils/mms-panel-utils'

const ViewInAR = defineAsyncComponent(() => import('@/js/pages/product/rackbuilder/components/ar/ViewInAR.vue'))
const GiftcardBalanceButton = defineAsyncComponent(() => import('../../pages/product/components/giftcard-balance-button.vue'))
const RhpaLoginDrawer = defineAsyncComponent(() => import('@/js/components/rhpa/programs/rhpa-login-drawer.vue'))
const RhpaBody = defineAsyncComponent(() => import('@/js/components/rhpa/rhpa-body.vue'))

const configStore = useConfigStore()
const customerStore = useCustomerStore()
const listStore = useListStore()
const productStore = useProductStore()
const uiStore = useUIStore()
const rogue = useRogue()
const router = useRouter()
const route = useRoute()
const emit = defineEmits(['addedToCart'])

const isOmQuotePage = inject('IS_OM_QUOTE_PAGE', false)

const props =  defineProps({
  buyRequest            : { type: Object as PropType<BuyRequest>, required: true },
  hideWishlist          : { type: Boolean, default: false },
  disabled              : { type: Boolean, default: true },
  validate              : { type: Function, required: false },
  forceShowPrice        : { type: Boolean, required: false, default: false },
  disableDigitalWallets : { type: Boolean, default: false },
  buttonOnly            : { type: Boolean, default: false },
})

const { BIN, clickBinButton } = useBackInStock(props.buyRequest)
const buyRequestRef = toRef(props, 'buyRequest')
const { STORAGE_SKUS, is3DStorageProduct, isMassStorage } = useMassStorage(buyRequestRef)

const inProgress = ref(false)
const applePayAvailable = ref(false)
const googlePayAvailable = ref(false)

const overlay = computed(() => uiStore.overlay)
const buyRequestStatus = computed(() => stockStatus.forBuyRequest(props.buyRequest, products.value))
const applePay = computed(() => configStore.applePay)
const isApparel = computed(() => groupMeta.value?.categories?.includes('Apparel') || groupMeta.value?.categories.includes('Shoes'))
const googlePay = computed(() => configStore.googlePay && isApparel.value)
const cart = computed(() => listStore.cart)
const defaultCreditCard = computed(() => customerStore.defaultCreditCard)
const defaultShippingAddress = computed(() => customerStore.defaultShippingAddress)
const earnedProducts = computed(() => customerStore.earnedProducts)
const itemHasPurchaseLimit = computed(() => Number(simple.value?.attributes?.purchase_limit) > 0)
const isProgram = computed(() => simple.value?.isProgram)
const loggedIn = computed(() => customerStore.loggedIn)
const groupMeta = computed(() => getBuyRequestMeta(props.buyRequest, rogue))
const products = computed(() => productStore.products)
const mainProduct = computed(() => productStore.products[props.buyRequest.productId] || {})
const virtualGiftCard = computed(() => props.buyRequest.isGiftcard && mainProduct.value?.giftcardData?.type === 'Virtual')

const quickBuyOnly = computed(() => mainProduct.value.attributes?.quick_buy_only || simple.value.attributes?.quick_buy_only)

const shouldDisablePromos = computed(() => route.query.disablePromos === '1')
const expressPaymentBuyRequest = computed(() => is3DStorageProduct.value ? buildExpressPaymentBuyRequest(props.buyRequest) : props.buyRequest)
// The shown total must price the panels the cart will get, not the ones the page shows.
const totalPriceBuyRequest = computed(() => {
  if (!is3DStorageProduct.value) return props.buyRequest

  const clone: BuyRequest = JSON.parse(JSON.stringify(props.buyRequest))
  raiseShortKitPanels(clone, rogue)

  return clone
})

// The whole-group footer under an accessory-layout grouped PDP; its main item already has a buttonOnly footer above.
const isAccessoryGroupFooter = computed(() => props.buyRequest.type === 'group' && !props.buttonOnly && Boolean(mainProduct.value.roguebuilder?.props?.isAccessoryProduct))

const groupedProduct = computed(() => {
  if ((mainProduct.value.type === 'grouped' && mainProduct.value.rhpaDisplayType !== 'swatch') || props.buyRequest.isEvent) {
    return mainProduct.value
  }

  return null
})

// Return the correct inventory object to use for stepper min/max values and HotDeals
const simple = computed(() => {
  let buyRequest = props.buyRequest
  while (buyRequest.children?.length) {
    // Try to find the best
    buyRequest = buyRequest.children.filter(c => c.qty > 0)[0] || buyRequest.children[0]
  }

  return products.value[buyRequest.productId] || { inventory: { min: 0, max: 0 } }
})

// Don't show the button on MMS regardless if feature flag is on or off or if its mass storage
const shouldShowAR = computed(() => !is3DStorageProduct.value)

const forceShipping = computed(() => {
  if (quickBuyOnly.value && (mainProduct.value.attributes?.quick_buy_address || simple.value.attributes?.quick_buy_address)) {
    return JSON.parse(String(mainProduct.value.attributes?.quick_buy_address) || String(simple.value.attributes?.quick_buy_address))
  }

  return false
})

const requiresCustomFooter = computed(() => is3DStorageProduct.value || isAccessoryFooterProduct.value)

// Computed, not set once on mount: under the client side render the footer can mount on the placeholder buyRequest before its children exist.
const accessoryCount = computed(() => (requiresCustomFooter.value ? props.buyRequest.children?.filter(child => child.type !== 'bundle').length || 0 : 0))

const ticketRequired = computed(() => {
  return mainProduct.value.attributes?.ticket_required || simple.value.attributes?.ticket_required
})

const hasTicketRemaining = computed(() => {
  if (!ticketRequired.value) {
    return true
  }

  const product = mainProduct.value.attributes.ticket_required ? mainProduct.value : simple.value

  return earnedProducts.value?.[product.productId] && !cart.value.items.some(item => item.productId === product.productId)
})

const disableBuy = computed(() => {
  return props.disabled || buyRequestStatus.value !== '' || (ticketRequired.value && !hasTicketRemaining.value)
})

const isTheCave = computed(() => isEnabledCustomProduct(rogue, 'cave', groupedProduct.value ?? undefined))

// RML SlingerX Addon is the only product that has an accessory for the Slinger Group
const isRMLSlingerXAddon = computed(() => mainProduct.value.sku === ML_SLINGER_X_ADDON_GROUP_SKU)

const isHybridRig = computed(() => isEnabledCustomProduct(rogue, 'hybrid-rig', groupedProduct.value ?? undefined))

// These share the same flat, non-bundle top-level accessory shape and the same footer treatment below.
const isAccessoryFooterProduct = computed(() => isTheCave.value || isRMLSlingerXAddon.value || isHybridRig.value)

const massStorageAccessories = computed(() => {
  return props.buyRequest?.children?.filter(item => productStore.products[item.productId]?.sku !== STORAGE_SKUS.value.BASE_UNIT_SKU
  && productStore.products[item.productId]?.sku !== STORAGE_SKUS.value.ADDON_SKU)
})

const theCaveAccessories = computed(() => props.buyRequest.children?.filter(child => child.type !== 'bundle'))

const msAccessoryBuyRequest = computed(() => {
  if (!is3DStorageProduct.value) return

  const clone = JSON.parse(JSON.stringify(props.buyRequest))

  return removeMSUnitsFromBuyRequest(clone)
})

const caveAccessoryBuyRequest = computed(() => {
  if (!isAccessoryFooterProduct.value) return

  const clone = JSON.parse(JSON.stringify(props.buyRequest))

  return removeCaveBundlesFromBuyRequest(clone)
})

const customBuyRequest = computed(() => {
  if (is3DStorageProduct.value) return msAccessoryBuyRequest.value
  if (isAccessoryFooterProduct.value) return caveAccessoryBuyRequest.value

  return props.buyRequest
})
const customRhpaAccessories = computed(() => is3DStorageProduct.value ? massStorageAccessories.value : theCaveAccessories.value)

const canAddAccessories = computed(() => {
  const accessories = is3DStorageProduct.value ? massStorageAccessories.value : theCaveAccessories.value

  return accessories?.some(acc => acc.qty > 0)
})

const arProps = computed(() => {
  if (rogue.appContext && !rogue.isApp('3.3.6')) {
    return null
  }

  // There is a corner case where a group product only has one child, and it shows up like a simple...
  // so groupedProduct is undefined but that is what has the rackbuilder props on it
  // Grouped product can be loaded from buyRequest.metadata.groupedProductId
  let visibleProduct = mainProduct.value

  if (!groupedProduct.value && props.buyRequest.metadata?.groupedProductId) {
    visibleProduct = products.value[props.buyRequest.metadata.groupedProductId] || visibleProduct
  }

  // Load the roguebuilder props
  const rbProps = visibleProduct.roguebuilder?.props || {}

  // Only show the AR button once in the Accessory mode RHPA for grouped products
  if (props.buyRequest.type === 'group' && !props.buttonOnly && rbProps.isAccessoryProduct && !isTheCave.value) {
    return null
  }

  // Check if the full media area has been taken over by Rackbuilder. If so, we want to show AR button
  const isMediaArea = rbProps.rackbuilder?.area === 'main'

  if (!isMediaArea && !rbProps.rackbuilder && !rbProps.ar) {
    return null
  }

  if (!rogue.featureFlags.isOn('enable_ar')) {
    return null
  }

  // If its the media area, it loads the rackbuilder / engine using the `provide / inject` system, so it doesn't need any properties
  // passed in.
  // @todo its complicated to have two implementations, how do we simplify this?
  if (isMediaArea || rbProps.rackbuilder?.arMesh || rbProps.rackbuilder?.type) {
    return {
      buyRequest   : props.buyRequest,
      hide3dButton : isMediaArea,
    }
  }

  // There are two ways to include AR in Rackbuilder... either a single `ar` property, or a `scene` property that lets you also define
  // camera position etc
  // In both cases, AR view depends on passing in the BuyRequest and scene / part configurations, since there probably are no other rackbuilders
  // on the page
  const part = rbProps.rackbuilder?.scene?.part || rbProps.ar

  if (part) {
    return {
      part,
      engineConfig : rbProps.rackbuilder?.config,
      buyRequest   : props.buyRequest,
      hide3dButton : isMediaArea,
    }
  }

  return null
})

function removeMSUnitsFromBuyRequest(buyRequest: BuyRequest) {
  buyRequest.children?.forEach((child) => {
    const product = rogue.getProductById(child.productId)
    const isMSUnit = [STORAGE_SKUS.value.BASE_UNIT_SKU, STORAGE_SKUS.value.ADDON_SKU]

    // Remove any qty set on the base / addon bundles and their children
    if (isMSUnit.includes(product?.sku)) {
      child.qty = 0

      child.children?.forEach((grandchild) => {
        grandchild.qty = 0
      })
    }
  })

  return buyRequest
}

function removeCaveBundlesFromBuyRequest(buyRequest: BuyRequest) {
  buyRequest.children?.forEach((child) => {
    if (child.type === 'bundle') {
      child.qty = 0
      child.children?.forEach((grandchild) => {
        grandchild.qty = 0
      })
    }
  })
  
  return buyRequest
}

async function prePurchase() {
  if (itemHasPurchaseLimit.value || isProgram.value) {
    if (!loggedIn.value) {
      uiStore.showOverlay('rhpaLogin', rogue)

      throw new Error('Not logged in for specified items')
    }

    if (props.validate) {
      await props.validate()
    }
  }

  if (props.validate && !(await props.validate())) {
    throw new Error('Invalid configuration')
  }

  // @todo move this into the `validate` param for giftcard rhpa
  if (props.buyRequest.isGiftcard) {
    if (!validateHelper(document.querySelector('.giftcard-opts') as Element)) {
      throw new Error('Invalid giftcard')
    }
  }
}

// BIN/OOS items have qty 0, so filterZeroQtyFromBuyRequest would drop them before export.
// Bump them to qty 1 so OM still receives them when quoting on the OM page.
function restoreBinQtyForExport(buyRequest: BuyRequest) {
  const status = stockStatus.forBuyRequest(buyRequest, products.value)
  const isProductUnavailable = status === 'bin' || status === 'oos'

  if (isProductUnavailable && buyRequest.qty === 0) {
    buyRequest.qty = 1
  }

  buyRequest.children?.forEach(child => restoreBinQtyForExport(child))

  return buyRequest
}

function filterZeroQtyFromBuyRequest(buyrequest: BuyRequest) {
  if (!Array.isArray(buyrequest.children)) {
    buyrequest.children = []

    return buyrequest
  }

  buyrequest.children = buyrequest.children
    .filter(child => child.qty !== 0)
    .map(child => filterZeroQtyFromBuyRequest(child))

  return buyrequest
}

// Assigns bolt-kit qtys onto the target buy request from its stored hardwareCount.
// MS splits the total across a 4-pack + 16-pack; MMS keeps its shared/solo kits.
function setHardwareQty(target: BuyRequest = props.buyRequest) {
  const children = target.children?.[0]?.children ?? []
  const hardwareCount = target.children?.[0]?.metadata?.hardwareCount

  if (!hardwareCount) return

  // MS has no shared/solo split — its hardwareCount is { fourPack, sixteenPack }.
  if (isMassStorage.value) {
    const fourPackBR = children.find(br => productStore.products[br.productId]?.sku === STORAGE_SKUS.value.FOUR_PACK_BOLT_KIT_SKU)
    const sixteenPackBR = children.find(br => productStore.products[br.productId]?.sku === STORAGE_SKUS.value.SIXTEEN_PACK_BOLT_KIT_SKU)

    if (fourPackBR) fourPackBR.qty = hardwareCount.fourPack ?? 0
    if (sixteenPackBR) sixteenPackBR.qty = hardwareCount.sixteenPack ?? 0

    return
  }

  const soloHardwareBR = children.find(br => productStore.products[br.productId]?.sku === STORAGE_SKUS.value.SOLO_BOLT_KIT_SKU)
  const sharedHardwareBR = children.find(br => productStore.products[br.productId]?.sku === STORAGE_SKUS.value.SHARED_BOLT_KIT_SKU)

  if (soloHardwareBR && sharedHardwareBR) {
    // `?? 0` guards against a stale MS-shaped hardwareCount ({ fourPack, sixteenPack })
    // reaching this MMS branch — reading .shared/.solo off it would otherwise assign NaN.
    const shared = hardwareCount.shared ?? 0
    const solo = hardwareCount.solo ?? 0

    // Same-SKU safety net (MMS): if both SKUs resolve to one BuyRequest, sum the counts.
    if (soloHardwareBR === sharedHardwareBR) {
      soloHardwareBR.qty = shared + solo
    } else {
      soloHardwareBR.qty = solo
      sharedHardwareBR.qty = shared
    }
  }
}

function buildExpressPaymentBuyRequest(buyRequest: BuyRequest) {
  const clone: BuyRequest = JSON.parse(JSON.stringify(buyRequest))
  setHardwareQty(clone)
  raiseShortKitPanels(clone, rogue)
  prepareCustomProductForCart(rogue, clone)

  return clone
}

async function exportToOrderManager() {
  inProgress.value = true

  try {
    if (props.validate && !(await props.validate())) {
      throw new Error('Invalid configuration')
    }
  } catch (e: any) {
    rogue.log.warn(`Error with prepurchase: ${e?.message || e}`, e)
    inProgress.value = false

    return
  }

  // Add shared and solo hardware qty to the buyrequest
  if (is3DStorageProduct.value) {
    setHardwareQty()
  }

  const buyRequestClone = JSON.parse(JSON.stringify(props.buyRequest))
  if (is3DStorageProduct.value) {
    raiseShortKitPanels(buyRequestClone, rogue)
  }
  prepareCustomProductForCart(rogue, buyRequestClone)

  if (isOmQuotePage) {
    restoreBinQtyForExport(buyRequestClone)
  }

  const flteredBuyRequest = filterZeroQtyFromBuyRequest(buyRequestClone)
  const orderManagerData = flteredBuyRequest.type === 'group' ? flteredBuyRequest.children : [flteredBuyRequest]

  // Make an API call to convert the buyRequest to OrderXML so order manager can process the data
  const response = await rogue.api.fetch({
    method : 'POST',
    url    : '/rogue_internal/svc_appdev/cart/item',
    data   : {
      storeId       : rogue.site.defaultStoreId,
      items         : orderManagerData,
      disablePromos : shouldDisablePromos.value,
    },
  }).catch((err: Error) => rogue.log.warn('Error with hostmatch', err))

  // Use postMessage to have appdev get the OrderXML data.
  if (response?.length) {
    console.log('API call succeeded and sending data via postMessage')
    window.parent.postMessage(response, "*")
  }

  inProgress.value = false
}

async function addAccessoriesToCart(list = 'cart') {
  if (!requiresCustomFooter.value) return

  const clone = JSON.parse(JSON.stringify(props.buyRequest))

  if (is3DStorageProduct.value) {
    removeMSUnitsFromBuyRequest(clone)
    await listStore.addListItems(rogue, list, [clone])
  } else if (isAccessoryFooterProduct.value) {
    const caveAccessories = clone.children?.filter((child: BuyRequest) => child.type !== 'bundle' && child.qty > 0) || []
    await listStore.addListItems(rogue, list, caveAccessories)
  }

  inProgress.value = false

  if (groupedProduct.value) {
    props.buyRequest.children?.forEach((child) => {
      child.qty = 0
    })
  }
}

function removeCaveAccessoriesFromBuyRequest(buyRequest: BuyRequest) {
  buyRequest.children?.forEach((child) => {
    if (child.type !== 'bundle') {
      child.qty = 0
      child.children?.forEach((grandchild) => {
        grandchild.qty = 0
      })
    }
  })

  return buyRequest
}

async function addToCart(list = 'cart') {
  // Program/eBook in the native webview: purchase in Safari — native shell expects a full URL (see app-bridge router).
  if (rogue.appContext && isProgram.value) {
    const url = typeof window !== 'undefined'
      ? `${window.location.origin}${route.fullPath}`
      : route.fullPath
    rogue.emitToApp(messages.OPEN_IN_BROWSER, { url })

    return
  }

  if (list === 'cart') {
    inProgress.value = true
  }

  try {
    await prePurchase()
  } catch (e: any) {
    rogue.log.warn(`Error with prepurchase: ${e?.message || e}`, e)
    inProgress.value = false

    return
  }

  // Add shared and solo hardware qty to the buyrequest
  if (is3DStorageProduct.value) {
    setHardwareQty()
  }

  // We need to clone the BR after prePurchase is called so we don't lose the recipe ID data for MMS
  const clone = JSON.parse(JSON.stringify(props.buyRequest))
  if (is3DStorageProduct.value) {
    raiseShortKitPanels(clone, rogue)
  }
  prepareCustomProductForCart(rogue, clone)

  // Used for bumper set breakdown, so drawer is closed and plateOpts are updated after add to cart
  emit('addedToCart')

  await listStore.addListItems(rogue, list, [clone])

  inProgress.value = false
  // eslint-disable-next-line 
  props.buyRequest.qty = simple.value?.inventory?.min || 1

  if (groupedProduct.value) {
    props.buyRequest.children?.forEach((child) => {
      child.qty = 0
    })

    // eslint-disable-next-line 
    props.buyRequest.qty = 1
  }

  // Used for bumper set breakdown, so the simple product qty's are updated back to 0
  if (Number(props.buyRequest.metadata?.plateOpts?.length) > 0) {
    // eslint-disable-next-line 
    props.buyRequest.qty = 0
  }

  if (list === 'buyNow') {
    if (forceShipping.value) {
      const { initOrder } = await import('@/js/pages/checkout/checkout')
      const rogueOrder = await initOrder(rogue)
      rogueOrder!.updateShippingAddress(forceShipping.value)
      rogueOrder!.data.forcedShipping = forceShipping.value
    }

    if (loggedIn.value) {
      if (defaultCreditCard.value) {
        router.push('/checkout/review')
      } else if (defaultShippingAddress.value) {
        router.push('/checkout/payment?qb=1')
      } else {
        router.push('/checkout/shipping')
      }
    } else {
      router.push('/checkout')
    }
  }
}


</script>
<style lang="scss" scoped>

.rhpa-footer {
  display: flex;
  align-items: center;

  .stepper {
    margin-right: $size-xxs;
  }
}

.digital-wallet-row {
  display: flex;
  gap: $space-xs;
  margin-top: $space-xs;

  .express-pay-button {
    flex: 1;
    min-width: 0;

    :deep(.gpay-card-info-container) {
      min-width: 0;
    }
  }
}

.grouped-price {
  flex-basis: 170px;
  max-width: 170px;

  &.wide {
    flex-shrink: 0;
    margin-right: $space-s;
  }
}

.lead {
  font-size: $size-xs;
}

.buy-now {
  margin-top: $space-s;
}

.gc-balance-button {
  margin: $space-s 0;
}

.ar-view {
  margin-bottom: $space-s;
}

.divider {
  height: 1px;
  background-color: $color-gray;
  margin: 8 0 $size-s;
}

.custom-divider {
  height: 1px;
  background-color: $color-gray;
  margin: 8px 0 8px $size-s;
}

.accessories-title {
  font-family: $font-condensed;
  font-size: $size-s;
  margin-top: $space-m;
  margin-bottom: $space-xxs;

  @include mobile() {
    font-size: $size-xs;
  }
}

.accessory-count {
  font-family: $font-base;
  text-transform: none;
  color: $color-gray-x-dark;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  display: inline-block;
  margin-left: $space-xxs;
}

</style>
